// Pure date maths for the manifest's day selector. Cabo Verde is UTC-1 all year (no DST), so "today there"
// is the UTC calendar date one hour back, and day stepping is plain calendar arithmetic. Kept UI-free so the
// SPA test setup (no DOM) can cover it.

function toYmd(d: Date): string {
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, '0');
  const day = String(d.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** The current local day in Cabo Verde as yyyy-MM-dd. */
export function todayInCaboVerde(now: Date = new Date()): string {
  return toYmd(new Date(now.getTime() - 60 * 60 * 1000));
}

/** Shift a yyyy-MM-dd day by whole days, returning yyyy-MM-dd. */
export function addDays(ymd: string, delta: number): string {
  const [y, m, d] = ymd.split('-').map(Number);
  const base = new Date(Date.UTC(y, m - 1, d));
  base.setUTCDate(base.getUTCDate() + delta);
  return toYmd(base);
}
